import { Debugger } from 'calling-cross-tab-library/utils/Debugger';
import { getIsDebugging } from 'calling-cross-tab-library/utils/getIsDebugging';
import once from 'shared-worker-versioning/lib/utils/once';
const CLIENT_DEBUGGER_NAME = `calling-cross-tab-client`;
let clientDebugger;
export const getClientDebugger = once(() => {
  try {
    if (getIsDebugging().messageDebug) {
      if (clientDebugger) return clientDebugger.log;
      clientDebugger = new Debugger(CLIENT_DEBUGGER_NAME);
      return clientDebugger.log;
    }
  } catch (e) {
    // nothing to see here.
  }
  return undefined;
});
export const logClientDebugMessage = (...args) => {
  const debug = getClientDebugger();
  if (debug) debug(...args);
};